"use client";
import { useEffect, useRef, useState } from "react";
import { ShouldAutoFocus } from "@ingka/modal-shared";
const AutoFocusOnMount = () => {
  const contentRef = useRef(null);
  const [wrapperFocus, setWrapperFocus] = useState(
    void 0
  );
  useEffect(() => {
    if (contentRef.current) {
      const wrapper = contentRef.current;
      setWrapperFocus(ShouldAutoFocus(wrapper));
    }
  }, []);
  return [wrapperFocus, contentRef];
};
var AutoFocusOnMount_default = AutoFocusOnMount;
export {
  AutoFocusOnMount,
  AutoFocusOnMount_default as default
};
